// import { useEffect, useMemo } from 'react';
// import { Outlet, useLocation, useSearchParams } from 'react-router-dom';

// import useMediaQuery from '@mui/material/useMediaQuery';
// import Container from '@mui/material/Container';
// import Toolbar from '@mui/material/Toolbar';
// import Box from '@mui/material/Box';

// import Drawer from './Drawer';
// import Header from './Header';
// import HorizontalBar from './Drawer/HorizontalBar';
// import Loader from 'components/Loader';
// import Breadcrumbs from 'components/@extended/Breadcrumbs';
// import AuthGuard from 'utils/route-guard/AuthGuard';
// import { MenuOrientation } from 'config';
// import useConfig from 'hooks/useConfig';
// import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// import { findBreadcrumbTrail } from '../../utils/breadcrumbsHelper';

// export default function DashboardLayout() {
//   const { pathname } = useLocation();
//   const [searchParams] = useSearchParams();
//   const aliasParam = searchParams.get('alias');
//   const { menuMaster, menuMasterLoading } = useGetMenuMaster();

//   const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
//   const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
//   const { container, miniDrawer, menuOrientation } = useConfig();
//   const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

//   useEffect(() => {
//     if (!miniDrawer) handlerDrawerOpen(!downXL);
//   }, [downXL, miniDrawer]);
//   const breadcrumbLinks = useMemo(() => {
//     const list = Array.isArray(menuMaster?.data) ? menuMaster.data : menuMaster;
//     if (!list || !Array.isArray(list)) return [];
//     const trail = findBreadcrumbTrail(list, pathname);
//     if (!trail?.length) return [];
//     return trail.map((item, i) => ({
//       title: item.alias || item.module_name,
//       to: i < trail.length - 1 ? item.module_path : undefined
//     }));
//   }, [menuMaster, pathname]);

//   if (menuMasterLoading) return <Loader />;

//   return (
//     <AuthGuard>
//       <Box sx={{ display: 'flex', width: '100%' }}>
//         <Header />
//         {!isHorizontal ? <Drawer /> : <HorizontalBar />}

//         <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 1, sm: 2 } }}>
//           <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />
//           <Container
//             maxWidth={container ? 'xl' : false}
//             sx={{
//               ...(container && { px: { xs: 0, sm: 1 } }),
//               position: 'relative',
//               minHeight: 'calc(100vh - 110px)',
//               display: 'flex',
//               flexDirection: 'column'
//             }}
//           >
//             {pathname !== '#!' && (
//               <Breadcrumbs
//                 icon
//                 title
//                 heading={aliasParam || breadcrumbLinks.at(-1)?.title}
//                 links={[{ title: 'Dashboard', to: '/dashboard-vehicle' }, ...breadcrumbLinks]}
//               />
//             )}

//             <Outlet />
//           </Container>
//         </Box>
//       </Box>
//     </AuthGuard>
//   );
// }

import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import HorizontalBar from './Drawer/HorizontalBar';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import AuthGuard from 'utils/route-guard/AuthGuard';

import { MenuOrientation } from 'config';
import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

const CUSTOM_BREADCRUMB_PATHS = [
  '/history-video',
  '/history-download-video',
  '/data-reports?type=vehicle_report',
  '/data-reports?type=trip_report',
  '/data-reports?type=driver_report',
  '/maps-monitoring'
];

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const location = useLocation();
  // === PERBAIKAN DI SINI ===
  const { pathname, search } = location;
  const fullPath = pathname + search; // Gabungkan path dan query parameter

  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  // Gunakan fullPath untuk mendeteksi '?type=...'
  const isCustomBreadcrumb = CUSTOM_BREADCRUMB_PATHS.some((path) => fullPath.includes(path));
  // =========================

  const { miniDrawer, menuOrientation } = useConfig();

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  useEffect(() => {
    if (!miniDrawer) {
      handlerDrawerOpen(!downXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <AuthGuard>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header />
        {!isHorizontal ? <Drawer /> : <HorizontalBar />}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            minWidth: 0,
            p: pathname.includes('/maps-monitoring') ? { xs: 0, sm: 0 } : { xs: 1, sm: 1 },
            display: 'flex',
            flexDirection: 'column',
            height: '100vh'
          }}
        >
          <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />
          <Container
            maxWidth={false}
            disableGutters
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              width: '100%',
              minHeight: 0,
              position: 'relative',
              overflow: pathname.includes('/maps-monitoring') ? 'hidden' : 'auto',
              px: pathname.includes('/maps-monitoring') ? { xs: 0, sm: 0 } : { xs: 1, sm: 1 }
            }}
          >
            {/* Breadcrumbs akan di-hide jika isCustomBreadcrumb = true */}
            {pathname !== '#!' && !isCustomBreadcrumb && <Breadcrumbs />}
            <Outlet />
          </Container>
        </Box>
      </Box>
    </AuthGuard>
  );
}
